import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { MenuNode } from 'shared';

import { environment } from '../../environments/environment';

type LocalUrlType = {
  value: string;
};

const localUrlLanguages: Record<string, LocalUrlType> = {
  ja: { value: 'ja-JP' },
  da: { value: 'da-DK' },
  de: { value: 'de-DE' },
  es: { value: 'es-ES' },
  fi: { value: 'fi-FI' },
  fr: { value: 'fr-FR' },
  it: { value: 'it-IT' },
  ko: { value: 'ko-KR' },
  nl: { value: 'nl-NL' },
  no: { value: 'no-NO' },
  pt: { value: 'pt-PT' },
  pl: { value: 'pl-PL' },
  sv: { value: 'sv-SE' },
  'zh-CN': { value: 'zh-CN' },
  'zh-TW': { value: 'zh-TW' },
};

@Injectable({
  providedIn: 'root',
})
export class NavService {
  public countryLanguage: string = '';

  public node1: Array<MenuNode> = [
    {
      label: $localize`Search`,
      url: 'manual/search',
      target: '_self',
    },
    {
      label: $localize`Update Information`,
      url: 'manual/update-info',
      target: '_self',
    },
    {
      label: $localize`Quick Guide`,
      url: 'information/other/quick-guide',
      target: '_self',
    },
  ];

  public node2: Array<MenuNode> = [
    {
      label: $localize`All Technical Documents`,
      url: 'https://productinfo.shimano.com',
      target: '_blank',
    },
    {
      label: $localize`Line-up chart`,
      url: 'https://productinfo.shimano.com/lineup',
      target: '_blank',
    },
    {
      label: $localize`Specifications`,
      url: 'https://productinfo.shimano.com/spec',
      target: '_blank',
    },
    {
      label: $localize`Compatibility`,
      url: 'https://productinfo.shimano.com/compatibility',
      target: '_blank',
    },
    {
      label: $localize`Archive`,
      url: 'https://productinfo.shimano.com/archive',
      target: '_blank',
    },
  ];

  public node3: Array<MenuNode> = [
    {
      label: $localize`All FAQ`,
      url: `https://bike.shimano.com/support-and-service/faq.html`,
      target: '_self',
      locale: [
        'bg',
        'cs',
        'el',
        'en',
        'et',
        'hr',
        'hu',
        'id',
        'lt',
        'lv',
        'ru',
        'ro',
        'sk',
        'sl',
        'sr',
        'th',
        'tr',
      ],
    },
    {
      label: $localize`All FAQ`,
      url: `https://bike.shimano.com/${
        localUrlLanguages[this.locale]?.value
      }/support-and-service/faq.html`,
      target: '_self',
      locale: [
        'da',
        'de',
        'es',
        'fi',
        'fr',
        'it',
        'ja',
        'ko',
        'nl',
        'no',
        'pl',
        'pt',
        'sv',
        'zh-CN',
        'zh-TW',
      ],
    },
    {
      label: 'Di2',
      url: `https://bike.shimano.com/support-and-service/faq/DI20A.html`,
      target: '_self',
      locale: [
        'bg',
        'cs',
        'el',
        'en',
        'et',
        'hr',
        'hu',
        'id',
        'lt',
        'lv',
        'ru',
        'ro',
        'sk',
        'sl',
        'sr',
        'th',
        'tr',
      ],
    },
    {
      label: 'Di2',
      url: `https://bike.shimano.com/${
        localUrlLanguages[this.locale]?.value
      }/support-and-service/faq/DI20A.html`,
      target: '_self',
      locale: [
        'da',
        'de',
        'es',
        'fi',
        'fr',
        'it',
        'ja',
        'ko',
        'nl',
        'no',
        'pl',
        'pt',
        'sv',
        'zh-CN',
        'zh-TW',
      ],
    },
    {
      label: 'SHIMANO E-BIKE SYSTEMS',
      url: `https://bike.shimano.com/support-and-service/faq/STP0A.html`,
      target: '_self',
      locale: [
        'bg',
        'cs',
        'el',
        'en',
        'et',
        'hr',
        'hu',
        'id',
        'lt',
        'lv',
        'ru',
        'ro',
        'sk',
        'sl',
        'sr',
        'th',
        'tr',
      ],
    },
    {
      label: 'SHIMANO E-BIKE SYSTEMS',
      url: `https://bike.shimano.com/${
        localUrlLanguages[this.locale]?.value
      }/support-and-service/faq/STP0A.html`,
      target: '_self',
      locale: [
        'da',
        'de',
        'es',
        'fi',
        'fr',
        'it',
        'ja',
        'ko',
        'nl',
        'no',
        'pl',
        'pt',
        'sv',
        'zh-CN',
        'zh-TW',
      ],
    },
    {
      label: 'Q’AUTO',
      url: `https://bike.shimano.com/support-and-service/faq/QAT0A.html`,
      target: '_self',
      locale: [
        'bg',
        'cs',
        'el',
        'en',
        'et',
        'hr',
        'hu',
        'id',
        'lt',
        'lv',
        'ru',
        'ro',
        'sk',
        'sl',
        'sr',
        'th',
        'tr',
      ],
    },
    {
      label: 'Q’AUTO',
      url: `https://bike.shimano.com/${
        localUrlLanguages[this.locale]?.value
      }/support-and-service/faq/QAT0A.html`,
      target: '_self',
      locale: [
        'da',
        'de',
        'es',
        'fi',
        'fr',
        'it',
        'ja',
        'ko',
        'nl',
        'no',
        'pl',
        'pt',
        'sv',
        'zh-CN',
        'zh-TW',
      ],
    },
    {
      label: $localize`Power Meter`,
      url: `https://bike.shimano.com/support-and-service/faq/FOV0A.html`,
      target: '_self',
      locale: [
        'bg',
        'cs',
        'el',
        'en',
        'et',
        'hr',
        'hu',
        'id',
        'lt',
        'lv',
        'ru',
        'ro',
        'sk',
        'sl',
        'sr',
        'th',
        'tr',
      ],
    },
    {
      label: $localize`Power Meter`,
      url: `https://bike.shimano.com/${
        localUrlLanguages[this.locale]?.value
      }/support-and-service/faq/FOV0A.html`,
      target: '_self',
      locale: [
        'da',
        'de',
        'es',
        'fi',
        'fr',
        'it',
        'ja',
        'ko',
        'nl',
        'no',
        'pl',
        'pt',
        'sv',
        'zh-CN',
        'zh-TW',
      ],
    },
    {
      label: 'SHIMANO CONNECT Lab',
      url: `https://bike.shimano.com/support-and-service/faq/SCL0A.html`,
      target: '_self',
      locale: [
        'bg',
        'cs',
        'el',
        'en',
        'et',
        'hr',
        'hu',
        'id',
        'lt',
        'lv',
        'ru',
        'ro',
        'sk',
        'sl',
        'sr',
        'th',
        'tr',
      ],
    },
    {
      label: 'SHIMANO CONNECT Lab',
      url: `https://bike.shimano.com/${
        localUrlLanguages[this.locale]?.value
      }/support-and-service/faq/SCL0A.html`,
      target: '_self',
      locale: [
        'da',
        'de',
        'es',
        'fi',
        'fr',
        'it',
        'ja',
        'ko',
        'nl',
        'no',
        'pl',
        'pt',
        'sv',
        'zh-TW',
      ],
    },
    {
      label: 'E-TUBE PROJECT Cyclist',
      url: `https://bike.shimano.com/support-and-service/faq/EPC0A.html`,
      target: '_self',
      locale: [
        'bg',
        'cs',
        'el',
        'en',
        'et',
        'hr',
        'hu',
        'id',
        'lt',
        'lv',
        'ru',
        'ro',
        'sk',
        'sl',
        'sr',
        'th',
        'tr',
      ],
    },
    {
      label: 'E-TUBE PROJECT Cyclist',
      url: `https://bike.shimano.com/${
        localUrlLanguages[this.locale]?.value
      }/support-and-service/faq/EPC0A.html`,
      target: '_self',
      locale: [
        'da',
        'de',
        'es',
        'fi',
        'fr',
        'it',
        'ja',
        'ko',
        'nl',
        'no',
        'pl',
        'pt',
        'sv',
        'zh-CN',
        'zh-TW',
      ],
    },
    {
      label: 'E-TUBE PROJECT Professional',
      url: `https://bike.shimano.com/support-and-service/faq/EPP0A.html`,
      target: '_self',
      locale: [
        'bg',
        'cs',
        'el',
        'en',
        'et',
        'hr',
        'hu',
        'id',
        'lt',
        'lv',
        'ru',
        'ro',
        'sk',
        'sl',
        'sr',
        'th',
        'tr',
      ],
    },
    {
      label: 'E-TUBE PROJECT Professional',
      url: `https://bike.shimano.com/${
        localUrlLanguages[this.locale]?.value
      }/support-and-service/faq/EPP0A.html`,
      target: '_self',
      locale: [
        'da',
        'de',
        'es',
        'fi',
        'fr',
        'it',
        'ja',
        'ko',
        'nl',
        'no',
        'pl',
        'pt',
        'sv',
        'zh-CN',
        'zh-TW',
      ],
    },
    {
      label: 'E-TUBE RIDE',
      url: `https://bike.shimano.com/support-and-service/faq/ERI0A.html`,
      target: '_self',
      locale: [
        'bg',
        'cs',
        'el',
        'en',
        'et',
        'hr',
        'hu',
        'id',
        'lt',
        'lv',
        'ru',
        'ro',
        'sk',
        'sl',
        'sr',
        'th',
        'tr',
      ],
    },
    {
      label: 'E-TUBE RIDE',
      url: `https://bike.shimano.com/${
        localUrlLanguages[this.locale]?.value
      }/support-and-service/faq/ERI0A.html`,
      target: '_self',
      locale: [
        'da',
        'de',
        'es',
        'fi',
        'fr',
        'it',
        'ja',
        'ko',
        'nl',
        'no',
        'pl',
        'pt',
        'sv',
        'zh-CN',
        'zh-TW',
      ],
    },
  ];

  public node4: Array<MenuNode> = [
    {
      label: $localize`All Compliance Documents`,
      url: 'compliance',
      target: '_self',
    },
    {
      label: $localize`Regulatory Information`,
      url: 'compliance/ri',
      target: '_self',
    },
    {
      label: $localize`Declaration of Conformity`,
      url: 'compliance/doc',
      target: '_self',
    },
    {
      label: $localize`Safety Data Sheet`,
      url: 'compliance/sds',
      target: '_self',
    },
    {
      label: $localize`Open Source Software`,
      url: 'compliance/oss',
      target: '_self',
    },
    {
      label: $localize`Microplastics Instruction`,
      url: 'compliance/spm',
      target: '_self',
      locale: [
        'bg',
        'cs',
        'da',
        'en',
        'es',
        'de',
        'el',
        'et',
        'fi',
        'fr',
        'hr',
        'hu',
        'it',
        'lt',
        'lv',
        'nl',
        'no',
        'pl',
        'pt',
        'ro',
        'sk',
        'sl',
        'sv',
        'tr',
      ],
    },
    {
      label: 'RoHS',
      url: 'compliance/rohs',
      target: '_self',
      locale: ['zh-CN'],
    },
    {
      label: $localize`Package Information`,
      url: 'compliance-search/pmi',
      target: '_self',
      locale: ['it'],
    },
    {
      label: $localize`Package Information`,
      url: 'compliance/pmi',
      target: '_self',
      locale: ['fr'],
    },
  ];

  public node5: Array<MenuNode> = [
    {
      label: $localize`Dealer's Manual & Exploded View`,
      url: 'manual/search?doctype=DM,UM,EV&series=CUES',
      target: '_self',
    },
    {
      label: $localize`Technical Documents`,
      url: '/pdfs/cues/technical-assets/CUES_Technical_Documents_LC_SHB_COMP.pdf',
      target: '_brank',
    },
    {
      label: $localize`SHIMANO Product Website`,
      url: 'https://bike.shimano.com/products/series/cues.html',
      target: '_brank',
    },
  ];

  public menuItems: Array<MenuNode> = [
    {
      label: $localize`Top`,
      url: '',
      children: this.node1,
      target: '_self',
    },
    {
      label: $localize`Technical Documents`,
      url: 'https://productinfo.shimano.com',
      children: this.node2,
      target: '_blank',
    },
    {
      label: $localize`Faq`,
      url: ``,
      target: '_self',
      children: this.node3,
    },
    {
      label: $localize`Error & Warning`,
      url: 'error',
      target: '_self',
    },
    {
      label: $localize`Compliance`,
      url: 'compliance',
      children: this.node4,
      target: '_self',
    },
    {
      label: 'CUES',
      url: 'cues',
      children: this.node5,
      target: '_self',
    },
    {
      label: $localize`Crank Inspection`,
      url: 'https://si.shimano.com/dm/RAFC012',
      target: '_self',
    },
  ];

  public publicLocales = [
    { locale: 'en', name: 'English' },
    { locale: 'ja', name: '日本語' },
    { locale: 'zh-CN', name: '简体中文' },
    { locale: 'zh-TW', name: '繁體中文' },
    { locale: 'fr', name: 'français' },
    { locale: 'es', name: 'español' },
    { locale: 'de', name: 'Deutsch' },
    { locale: 'it', name: 'Italiano' },
    { locale: 'cs', name: 'Česky' },
    { locale: 'sk', name: 'Slovensky' },
    { locale: 'hu', name: 'Magyar' },
    { locale: 'ru', name: 'Русский' },
    { locale: 'nl', name: 'Nederlands' },
    { locale: 'sv', name: 'svenska' },
    { locale: 'fi', name: 'suomi' },
    { locale: 'no', name: 'Norsk' },
    { locale: 'pl', name: 'Polski' },
    { locale: 'da', name: 'dansk' },
    { locale: 'lt', name: 'Lietuvių kalba' },
    { locale: 'lv', name: 'Latviski' },
    { locale: 'et', name: 'Eesti' },
    { locale: 'el', name: 'Ελληνικά' },
    { locale: 'sl', name: 'Slovenščina' },
    { locale: 'ro', name: 'Română' },
    { locale: 'bg', name: 'Български' },
    { locale: 'tr', name: 'Türkçe' },
    { locale: 'sr', name: 'Српски' },
    { locale: 'hr', name: 'Hrvatski' },
    { locale: 'pt', name: 'Português' },
    { locale: 'ko', name: '한국어' },
    { locale: 'th', name: 'ไทย' },
    { locale: 'id', name: 'Bahasa Indonesia' },
  ];

  public message = '';

  constructor(@Inject(LOCALE_ID) private locale: string) {}

  getNav(): Array<MenuNode> {
    this.menuItems.map((menuItem) => {
      if (menuItem.children !== undefined) {
        menuItem.children = menuItem.children.filter((item) => {
          if (item.locale !== undefined) {
            if (item.locale.indexOf(this.locale) !== -1) {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        });
      }
    });

    return this.menuItems;
  }

  getPublicLocales(): Array<any> {
    return this.publicLocales;
  }
}
